import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import Modal from 'trunks/vue/admin/components/modals/modal.js'
import { newConfirm } from 'trunks/vue/admin/components/libs/confirm.js'
import MenuButtonList from './wechat_menu/menu_button_list.js'
import MenuButtonDetails from './wechat_menu/menu_button_details.js'
import MenuPreview from './wechat_menu/menu_preview.js'
import {
  parseButtons,
  serializeButtons,
  cloneButtonState,
  createEmptyButton,
  createEmptySubButton,
  changeButtonType,
  changeButtonKey,
  validateNameLength
} from './wechat_menu/button_utils.js'

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    Modal,
    MenuButtonList,
    MenuButtonDetails,
    MenuPreview
  },

  props: {
    activeTab: {
      type: String
    },
    menuData: {
      type: Object
    }
  },

  data() {
    const {
      menu_payload: menuPayload,
      paths,
      click_buttons: clickButtons,
      limits,
      has_sync_button: hasSyncButton = true,
      labels = {}
    } = this.menuData
    const mergedLabels = {
      title: '微信菜单',
      list_title: '菜单管理',
      detail_title: '按钮细节描述',
      empty_text: '当前还没有菜单！',
      preview_title: '预览',
      preview_button: '预览',
      sync_button: '从微信同步',
      sync_confirm_title: '确定从微信同步菜单？',
      sync_confirm_message: '同步后将使用微信公众号上的菜单覆盖当前编辑内容。',
      sync_success: '菜单已成功从微信同步',
      sync_error: '同步失败',
      save_button: '发布',
      saving_button: '发布中...',
      save_success: '菜单发布成功',
      save_error: '发布失败',
      ...labels
    }
    return {
      buttons: parseButtons(menuPayload, { hasSyncButton, clickButtons }),
      paths,
      clickButtons,
      limits,
      hasSyncButton,
      labels: mergedLabels,
      selectedPath: null,
      originButton: null,
      validateTimer: null,
      saving: false,
      syncing: false,
      previewOpen: false,
      previewButtons: []
    }
  },

  computed: {
    selectedButton() {
      return this.getButtonByPath(this.selectedPath)
    },

    selectedIsRoot() {
      return this.selectedPath && this.selectedPath.childIndex == null
    },

    isEmpty() {
      return this.buttons.length === 0
    },

    buttonOptions() {
      return {
        hasSyncButton: this.hasSyncButton,
        clickButtons: this.clickButtons
      }
    }
  },

  methods: {
    getButtonByPath(path) {
      if (!path) {
        return null
      }
      const root = this.buttons[path.rootIndex]
      if (!root) {
        return null
      }
      if (path.childIndex != null) {
        return (root.sub_button || [])[path.childIndex] || null
      }
      return root
    },

    setButtonByPath(path, updater) {
      const buttons = cloneButtonState(this.buttons)
      const root = buttons[path.rootIndex]
      if (!root) {
        return
      }
      if (path.childIndex != null) {
        root.sub_button[path.childIndex] = updater(root.sub_button[path.childIndex])
      } else {
        buttons[path.rootIndex] = updater(root)
      }
      this.buttons = buttons
    },

    onSelect(path) {
      if (this.selectedPath) {
        const prev = this.getButtonByPath(this.selectedPath)
        if (prev) {
          // keep selection highlight in list via selectedPath only
        }
      }
      const button = this.getButtonByPath(path)
      this.selectedPath = path
      this.originButton = button ? cloneButtonState(button) : null
    },

    onRemove(path) {
      const buttons = cloneButtonState(this.buttons)
      if (path.childIndex != null) {
        const root = buttons[path.rootIndex]
        root.sub_button.splice(path.childIndex, 1)
        if (
          this.selectedPath &&
          this.selectedPath.rootIndex === path.rootIndex &&
          this.selectedPath.childIndex === path.childIndex
        ) {
          this.selectedPath = null
          this.originButton = null
        }
      } else {
        buttons.splice(path.rootIndex, 1)
        if (this.selectedPath && this.selectedPath.rootIndex === path.rootIndex) {
          this.selectedPath = null
          this.originButton = null
        }
      }
      this.buttons = buttons
    },

    onAddSub(path) {
      this.setButtonByPath(path, (button) => {
        const subButton = createEmptySubButton(this.buttonOptions)
        const subButtons = [...(button.sub_button || []), subButton]
        return {
          ...button,
          sub_button: subButtons,
          url: ''
        }
      })
      const root = this.buttons[path.rootIndex]
      const childIndex = (root.sub_button || []).length - 1
      this.onSelect({ rootIndex: path.rootIndex, childIndex })
    },

    onSort({ parentPath, startIndex, endIndex }) {
      if (startIndex === endIndex) {
        return
      }
      const buttons = cloneButtonState(this.buttons)
      if (parentPath) {
        const root = buttons[parentPath.rootIndex]
        const item = root.sub_button.splice(startIndex, 1)[0]
        root.sub_button.splice(endIndex, 0, item)
      } else {
        const item = buttons.splice(startIndex, 1)[0]
        buttons.splice(endIndex, 0, item)
      }
      this.buttons = buttons
    },

    addRootMenu() {
      if (this.limits.max_menu_length && this.buttons.length >= this.limits.max_menu_length) {
        Skylark.Bridge.newAlertify(`一级菜单最多${this.limits.max_menu_length}个!`, { type: 'warning' })
        return
      }
      const button = createEmptyButton('新菜单', this.buttonOptions)
      this.buttons = [...this.buttons, button]
      this.onSelect({ rootIndex: this.buttons.length - 1 })
    },

    onUpdateField({ field, value }) {
      if (!this.selectedPath) {
        return
      }
      this.setButtonByPath(this.selectedPath, (button) => ({ ...button, [field]: value }))
    },

    onValidateName(name) {
      if (this.validateTimer) {
        clearTimeout(this.validateTimer)
      }
      this.validateTimer = setTimeout(() => {
        const valid = validateNameLength(name, {
          isRoot: this.selectedIsRoot,
          limits: this.limits
        })
        if (!valid) {
          Skylark.Bridge.newAlertify('您输入的长度过长！', { type: 'warning' })
        }
      }, 600)
    },

    onChangeType(type) {
      if (!this.selectedPath) {
        return
      }
      this.setButtonByPath(this.selectedPath, (button) =>
        changeButtonType(button, type, this.clickButtons)
      )
    },

    onChangeKey(key) {
      if (!this.selectedPath) {
        return
      }
      this.setButtonByPath(this.selectedPath, (button) =>
        changeButtonKey(button, key, this.clickButtons)
      )
    },

    onResetDetails() {
      if (!this.selectedPath || !this.originButton) {
        return
      }
      this.setButtonByPath(this.selectedPath, () => cloneButtonState(this.originButton))
    },

    snapshotOrigins() {
      this.buttons.forEach((root) => {
        root.originButton = cloneButtonState(root)
        ;(root.sub_button || []).forEach((sub) => {
          sub.originButton = cloneButtonState(sub)
        })
      })
    },

    openPreview() {
      if (this.isEmpty) {
        Skylark.Bridge.newAlertify('当前还没有菜单！', { type: 'warning' })
        return
      }
      this.previewButtons = cloneButtonState(this.buttons)
      this.previewOpen = true
    },

    closePreview() {
      this.previewOpen = false
    },

    openSyncConfirm() {
      if (!this.hasSyncButton) {
        return
      }
      newConfirm({
        title: this.labels.sync_confirm_title,
        message: this.labels.sync_confirm_message,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).$on('ensureClicked', () => {
        this.syncFromWechat()
      })
    },

    syncFromWechat() {
      this.syncing = true
      Skylark.Libs.Ajax.get(this.paths.remote, {
        responseType: 'json',
        success: (data) => {
          const payload = data.menu_payload || {}
          this.buttons = parseButtons(payload, {
            hasSyncButton: this.hasSyncButton,
            clickButtons: this.clickButtons
          })
          this.selectedPath = null
          this.originButton = null
          Skylark.Bridge.newAlertify(this.labels.sync_success, { type: 'success' })
        },
        error: (xhr) => {
          let msg = this.labels.sync_error
          try {
            msg = JSON.parse(xhr.responseText).errmsg || msg
          } catch (e) {
            // ignore parse error
          }
          Skylark.Bridge.newAlertify(`${this.labels.sync_error}：${msg}`, { type: 'danger' })
        },
        complete: () => {
          this.syncing = false
        }
      })
    },

    saveButtons() {
      const serialized = serializeButtons(this.buttons)
      this.saving = true
      Skylark.Libs.Ajax.patch(this.paths.update, {
        data: {
          namespace: {
            menu_payload: {
              button: serialized
            }
          }
        },
        responseType: 'json',
        success: () => {
          this.snapshotOrigins()
          if (this.selectedPath) {
            this.originButton = cloneButtonState(this.getButtonByPath(this.selectedPath))
          }
          Skylark.Bridge.newAlertify(this.labels.save_success, { type: 'success' })
        },
        error: (xhr) => {
          let msg = this.labels.save_error
          try {
            msg = `${this.labels.save_error}：${JSON.parse(xhr.responseText).errmsg}`
          } catch (e) {
            // ignore
          }
          Skylark.Bridge.newAlertify(msg, { type: 'danger' })
        },
        complete: () => {
          this.saving = false
        }
      })
    }
  },

  template: `
    <settings-container :activeTab="activeTab">
      <template slot="content">
        <div class="wechat-menu-settings">
          <div class="panel-card wechat-menu-editor">
            <div class="panel-card-head wechat-menu-editor-head">
              <span class="panel-card-title">{{ labels.title }}</span>
            </div>
            <div class="panel-card-body wechat-menu-editor-body">
              <div class="wechat-menu-columns">
                <div class="wechat-menu-list-panel">
                  <div class="wechat-menu-list-header">
                    <span>{{ labels.list_title }}</span>
                    <button
                      type="button"
                      class="wechat-menu-add-root"
                      title="添加菜单"
                      @click="addRootMenu"
                    >
                      <i class="slp-plus"></i>
                    </button>
                  </div>
                  <div class="wechat-menu-list-body">
                    <p v-if="isEmpty" class="empty-menu-text">{{ labels.empty_text }}</p>
                    <menu-button-list
                      v-else
                      :buttons="buttons"
                      :selected-path="selectedPath"
                      :limits="limits"
                      @select="onSelect"
                      @remove="onRemove"
                      @add-sub="onAddSub"
                      @sort="onSort"
                    />
                  </div>
                </div>
                <div class="wechat-menu-details-panel">
                  <div class="wechat-menu-list-header">
                    <span>{{ labels.detail_title }}</span>
                  </div>
                  <div class="wechat-menu-details-body">
                    <menu-button-details
                      :button="selectedButton"
                      :click-buttons="clickButtons"
                      :limits="limits"
                      :is-root="selectedIsRoot"
                      @update-field="onUpdateField"
                      @validate-name="onValidateName"
                      @change-type="onChangeType"
                      @change-key="onChangeKey"
                      @reset="onResetDetails"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-footer wechat-menu-footer">
          <button
            v-if="hasSyncButton"
            type="button"
            class="outlined btn-default content-footer-btn content-footer-btn--secondary"
            :disabled="syncing"
            @click="openSyncConfirm"
          >
            {{ labels.sync_button }}
          </button>
          <button
            type="button"
            class="outlined btn-default content-footer-btn"
            @click="openPreview"
          >
            {{ labels.preview_button }}
          </button>
          <button
            type="button"
            class="content-footer-btn"
            :disabled="saving"
            @click="saveButtons"
          >
            {{ saving ? labels.saving_button : labels.save_button }}
          </button>
        </div>

        <modal
          v-if="previewOpen"
          :title="labels.preview_title"
          size="small"
          :backdrop="false"
          extend-class="wechat-menu-preview-modal"
          @maskClicked="closePreview"
          @afterClosed="closePreview"
        >
          <menu-preview :buttons="previewButtons" />
          <div slot="footer" class="wechat-menu-preview-no-footer" aria-hidden="true"></div>
        </modal>
      </template>
    </settings-container>
  `
})
